"use client";

import { CapabilityPage } from "@/components/sections/page-composer";
import { integrationGuidesData } from "@/lib/data/developers-integration-guides";

export function IntegrationGuidesPage() {
  return <CapabilityPage data={integrationGuidesData} />;
}
